import useDictionary from 'hooks/useDictionary';
import { useHistory } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { breadcrumbHeader } from 'store/atom-state/breadcrumb-header';

const BreadcrumbHeader = () => {
  const { t }: any = useDictionary({});
  const history = useHistory();
  const breadcrumbData = useRecoilValue(breadcrumbHeader);

  const onclickBeadcrumb = router => {
    history.push(router || '/');
  };

  return (
    <nav>
      <div
        style={{
          height: 35,
          background: '#F9FAFB',
          display: 'flex',
          gap: 10,
          alignItems: 'center',
        }}
      >
        <div style={{ display: 'flex', gap: 10 }}>
          <span
            style={{
              color: 'blue',
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: 14,
            }}
            onClick={() => onclickBeadcrumb(breadcrumbData?.root.router)}
          >
            {t(breadcrumbData?.root?.label || '')}
          </span>
        </div>
        {(breadcrumbData?.data || []).map((b, idx) => {
          if (idx === 0) {
            return (
              <div style={{ display: 'flex', gap: 10 }} key={idx}>
                <span>{'>'}</span>
                <span>{t(b.label || '')}</span>
              </div>
            );
          } else {
            return (
              <div style={{ display: 'flex', gap: 10 }} key={idx}>
                <span>{'>'}</span>
                <span
                  style={{
                    color: 'blue',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }}
                  onClick={() => onclickBeadcrumb(b.router)}
                >
                  {t(b.label || '')}
                </span>
              </div>
            );
          }
        })}
      </div>
    </nav>
  );
};

export default BreadcrumbHeader;
